import { PartnerAPIConfig } from '../../models';

const config: PartnerAPIConfig = {
  COGNITO_CLIENT_ID: '1jvij5g5rippjk6o5qo4l3ke46',
  COGNITO_USER_POOL_ID: 'us-east-1_23eX5TEDs',
  AUTH_API_PARTNER_CODE: 'Verizon',
};

export default config;



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/config/prod/TCH-WEB.ts